import React, { Component } from 'react';

export default class DoubleCheck extends Component {
	render() {
		return (
			<svg
				version='1.1'
				id='Capa_1'
				xmlns='http://www.w3.org/2000/svg'
				xmlnsXlink='http://www.w3.org/1999/xlink'
				x='0px'
				y='0px'
				viewBox='0 0 214.864 214.864'
				xmlSpace='preserve'
				fill={this.props.color}
				style={this.props.style}
			>
				<g>
					<path
						d='M208.35,56.943c-8.703-8.7-22.864-8.702-31.567,0l-53.626,53.625l-3.414-3.414l18.644-18.644
		c0.183-0.183,0.355-0.374,0.515-0.57c8.16-8.74,8.004-22.477-0.515-30.996c-4.216-4.217-9.82-6.538-15.783-6.538
		s-11.567,2.321-15.784,6.537l-53.625,53.625l-15.091-15.09c-8.703-8.701-22.863-8.701-31.566,0C2.321,99.695,0,105.299,0,111.262
		c0,5.844,2.241,11.334,6.299,15.52c0.08,0.087,0.153,0.179,0.238,0.263l30.835,30.835c0.013,0.013,0.023,0.028,0.037,0.041
		c4.217,4.216,9.821,6.537,15.784,6.537c5.962,0,11.566-2.321,15.783-6.537l0.002-0.002l0,0l0,0l19.197-19.197l19.159,19.159
		c0.013,0.013,0.023,0.028,0.037,0.041c4.217,4.216,9.821,6.537,15.783,6.537c5.963,0,11.567-2.321,15.784-6.537L208.35,88.51
		c0.183-0.183,0.355-0.374,0.515-0.57C217.025,79.2,216.869,65.463,208.35,56.943z M17.144,106.086
		c2.854-2.853,7.499-2.854,10.354,0l20.394,20.394c0.183,0.183,0.374,0.354,0.57,0.515c1.375,1.121,3.055,1.682,4.734,1.682
		s3.359-0.561,4.734-1.682c0.196-0.16,0.387-0.332,0.57-0.515l58.929-58.929c1.383-1.383,3.221-2.145,5.177-2.145
		c1.955,0,3.793,0.761,5.176,2.145c2.854,2.854,2.854,7.498,0,10.353l-69.408,69.409c-1.383,1.383-3.221,2.145-5.176,2.145
		c-1.956,0-3.794-0.762-5.177-2.145l-30.874-30.874c-0.002-0.002-0.004-0.003-0.005-0.005c-1.38-1.382-2.139-3.218-2.139-5.171
		C15,109.306,15.762,107.468,17.144,106.086z M109.135,117.762l8.717,8.717c1.465,1.464,3.384,2.196,5.304,2.196
		c1.919,0,3.839-0.732,5.304-2.196l58.93-58.929c2.854-2.856,7.499-2.854,10.353,0c2.854,2.854,2.854,7.498,0,10.353l-69.409,69.409
		c-1.383,1.383-3.221,2.145-5.177,2.145c-1.955,0-3.793-0.762-5.176-2.145l-19.197-19.198L109.135,117.762z'
					/>
				</g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
			</svg>
		);
	}
}
